import React from "react";


export default class StepInputGroup extends React.Component {
    render() {
        return <span className={"step_input_label"}>
            {this.props.children}
        </span>
    }
}